// Leitura de CSV compartilhada (importação de lançamentos e de fatura de cartão).
export const normalizeText = (t) => (t || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

// Lê o arquivo como UTF-8; se não for UTF-8 válido (Excel antigo), tenta Windows-1252.
export function decodeCsvBuffer(buffer) {
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(buffer).replace(/^\uFEFF/, '');
  } catch {
    return new TextDecoder('windows-1252').decode(buffer);
  }
}

// ";" (Excel em português), "," ou tabulação — escolhe o que mais aparece no cabeçalho
export function detectDelimiter(headerLine) {
  const count = (c) => (headerLine.match(new RegExp(c === '\t' ? '\\t' : `\\${c}`, 'g')) || []).length;
  const options = [';', ',', '\t'].map(c => ({ c, n: count(c) }));
  options.sort((a, b) => b.n - a.n);
  return options[0].n > 0 ? options[0].c : ';';
}

export function parseCsvLine(line, delimiter) {
  const result = [];
  let current = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === delimiter && !inQuotes) {
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }
  result.push(current.trim());
  return result;
}

// Aceita DD/MM/AAAA (padrão brasileiro) e AAAA-MM-DD; devolve AAAA-MM-DD ou null
export function parseDate(value) {
  const v = (value || '').trim();
  let y; let m; let d;
  let match = v.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (match) { [, y, m, d] = match; } else {
    match = v.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2}|\d{4})$/);
    if (!match) return null;
    [, d, m, y] = match;
    if (y.length === 2) y = `20${y}`;
  }
  const dt = new Date(Number(y), Number(m) - 1, Number(d));
  if (dt.getFullYear() !== Number(y) || dt.getMonth() !== Number(m) - 1 || dt.getDate() !== Number(d)) return null;
  return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}

// Aceita "1500,00", "1.500,00", "1500.00" e "R$ 1.500,00"
export function parseValor(value) {
  let v = (value || '').toString().replace(/R\$|\s/g, '');
  if (!v) return NaN;
  const lastComma = v.lastIndexOf(',');
  const lastDot = v.lastIndexOf('.');
  if (lastComma > -1 && lastDot > -1) {
    v = lastComma > lastDot ? v.replace(/\./g, '').replace(',', '.') : v.replace(/,/g, '');
  } else if (lastComma > -1) {
    v = v.replace(',', '.');
  } else if (lastDot > -1 && /^\d{1,3}(\.\d{3})+$/.test(v)) {
    v = v.replace(/\./g, ''); // 1.500 → 1500 (milhar brasileiro)
  }
  return parseFloat(v);
}
